const HEAD_CLASS = '.js-list-view-head';

const SORTED_CLASS = 'is-sorted';
const SORTED_ASC_CLASS = 'is-sorted-asc';
const SORTED_DESC_CLASS = 'is-sorted-desc';

const Sort = {
  /**
   * Create Sort for the list view component
   * @param {HTMLElement} listViewNode
   * @return {void}
   */
  initialize(listViewNode, cb) {
    this.cb = cb;
    this.$tableHead = $(listViewNode).find(HEAD_CLASS);
    this.createListeners();
  },

  /**
   * Create event listeners for sorting
   * @return {void}
   */
  createListeners() {
    this.$tableHead.on('click', 'th[data-sortable]', (e) => {
      const $el = $(e.currentTarget);
      const isSortedOn = $el.hasClass(SORTED_CLASS);
      const isSortedAsc = $el.hasClass(SORTED_ASC_CLASS);
      const isSortedDesc = $el.hasClass(SORTED_DESC_CLASS);
      const columnName = $el.data('column');

      let direction = 'none';

      if (isSortedOn && isSortedAsc) {
        direction = 'desc';
      } else if (!isSortedOn && !isSortedDesc) {
        direction = 'asc';
      }

      this.setStyle(columnName, direction);

      this.cb(columnName, direction);
    });
  },

  /**
   * Get table head element
   * @return {Object}
   */
  getTableHeads() {
    return this.$tableHead.find('th');
  },

  /**
   * Get column element by name
   * @param {String} name
   * @return {Object}
   */
  getColumn(name) {
    return this.$tableHead.find(`th[data-column="${name}"]`);
  },

  /**
   * Remove all styles from the table heads
   * @return {void}
   */
  removeAllSortingClasses() {
    const $tableHeads = this.getTableHeads();
    $tableHeads.removeClass(`${SORTED_CLASS} ${SORTED_DESC_CLASS} ${SORTED_ASC_CLASS}`);
    $tableHeads.find('.fas').removeClass('fa-sort-up fa-sort-down').addClass('fa-sort');
  },

  /**
   * Set style on the table heads based on the sorting
   * @param {String} columnName
   * @param {String} direction
   * @return {void}
   */
  setStyle(columnName, direction) {
    const $column = this.getColumn(columnName);

    this.removeAllSortingClasses();

    if (direction === 'none') {
      return;
    }

    const $icon = $column.find('.fas');

    $icon
      .toggleClass('fa-sort-down', direction === 'asc')
      .toggleClass('fa-sort-up', direction === 'desc');

    $column
      .addClass(SORTED_CLASS)
      .toggleClass(SORTED_ASC_CLASS, direction === 'asc')
      .toggleClass(SORTED_DESC_CLASS, direction === 'desc');
  },
};

export default Sort;
